const baseStyle = {};
const defaultProps = {
    size: 'md'
};
const sizes = {
    xs: {
        fontSize: 'xs'
    },
    sm: {
        fontSize: 'sm'
    },
    md: {
        fontSize: 'md'
    },
    lg: {
        fontSize: 'lg'
    }
};
const variants = {
    label: {
        fontSize: 'md',
        fontWeight: 'demi'
    },
    caption: {
        fontSize: 'sm',
        fontWeight: 'medium'
    }
};
export default {
    baseStyle,
    defaultProps,
    sizes,
    variants
};
